// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2B137","bigColWidth":"Table_bigColWidth__1Gp-A","biggerColWidth":"Table_biggerColWidth__2x3SV","row":"Table_row__1d8AH","col":"Table_col__3Kz9A"};